/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import * as styles from './review.styl'
import * as alertSettingsFieldStyles from './alert.settings.field.styl'
import Field from '../../common/field'
import { find, uniq } from 'lodash'
import { correctEmailFormat } from '@src/utils/accounts'
import type { StepProps } from '../models'
import { StepTypes } from '../models/step.types'

export const ReviewAndSave: React.FC<StepProps> = (props: StepProps) => {
  const { steps, footerComponent, user, tenant } = props
  const isAccountInfo = find(
    steps,
    s => s.stepType === StepTypes.USER_INFORMATION
  )
  const isAlertSettings = find(
    steps,
    s => s.stepType === StepTypes.ALERT_SETTINGS
  )

  function renderUserInformation() {
    return (
      <div role="user-information" className={styles.userInformationSummary}>
        <div className={styles.sectionHeader}>User Information</div>
        <div className={styles.fieldsWrapper}>
          <Field
            role="first-name"
            label="First Name"
            value={user?.first_name}
          />
          <Field role="last-name" label="Last Name" value={user?.last_name} />
          <Field
            role="email"
            label="Email"
            value={correctEmailFormat(user?.email)}
          />
          <Field
            role="location"
            label="Location"
            value={tenant?.address || 'none'}
          />
          <Field
            role="job-title"
            label="Job Title"
            value={user?.role || 'none'}
          />
        </div>
      </div>
    )
  }

  function renderAlertSettings() {
    const alertInfo = user?.alert_info || {}
    const sharedWith = tenant?.alertSettings || []
    let alertEmails: Array<string | string[]> = sharedWith.map(e => e.email)
    alertEmails = alertEmails.flat(2)
    alertEmails = uniq(alertEmails)
    const enabled = []
    const disabled = []
    if (alertInfo.changes_in_config) {
      enabled.push('Changes in Configuration')
    } else {
      disabled.push('Changes in Configuration')
    }

    if (alertInfo.health_and_dialog_issue_found) {
      enabled.push('Health and Diagnostic Issue Found')
    } else {
      disabled.push('Health and Diagnostic Issue Found')
    }

    if (alertInfo.new_user_found) {
      enabled.push('New User Found')
    } else {
      disabled.push('New User Found')
    }

    // if (alertSettings.licensePolicyIssues) {
    //   enabled.push('License Policy Issues')
    // } else {
    //   disabled.push('License Policy Issues')
    // }

    return (
      <div role="alert-settings" className={styles.alertSettingsSummary}>
        <div className={styles.sectionHeader}>Alert Settings</div>
        <div className={styles.subHeader}>Alert Notifications</div>
        <div className={styles.fieldsWrapper}>
          <Field
            role="enabled"
            label="Enabled"
            value={enabled.join(', ')}
            customStyles={alertSettingsFieldStyles}
          />
          <Field
            role="disabled"
            label="Disabled"
            value={disabled.join(', ')}
            customStyles={alertSettingsFieldStyles}
          />
        </div>
        <div className={styles.subHeader}>Notification Methods</div>
        <div className={styles.fieldsWrapper}>
          <Field
            role="primary-email"
            label="Primary Email"
            value={correctEmailFormat(user?.email)}
            customStyles={alertSettingsFieldStyles}
          />
          <Field
            role="shared-with"
            label="Shared with"
            value={alertEmails.join(', ')}
            customStyles={alertSettingsFieldStyles}
          />
        </div>
        {/* <div className={styles.subHeader}>Syslog Configuration</div>
        <div className={styles.syslogFieldsWrapper}>
          <Field
            label="IP Address"
            value={alertSettings.ipAddress}
            customStyles={syslogFieldStyles}
          />
          <Field
            label="Port"
            value={alertSettings.port}
            customStyles={syslogFieldStyles}
          />
          <Field
            label="Verified on"
            value={alertSettings.verifiedOn}
            customStyles={syslogFieldStyles}
          />
        </div> */}
      </div>
    )
  }

  return (
    <>
      <div className={styles.content}>
        {isAccountInfo ? renderUserInformation() : null}
        {isAlertSettings ? renderAlertSettings() : null}
      </div>
      {footerComponent
        ? React.createElement(footerComponent, {
            ...props
          })
        : null}
    </>
  )
}
